import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTutorialById } from "../utils/api";

export const fetchTutorialById = createAsyncThunk(
  'tutorial/fetchTutorialById',
  async ({accessToken, id}, thunkAPI) => {
    const response = await getTutorialById(accessToken, id);

    if (!response.data.success) {
      throw new Error('Failed to fetch tutorial');
    }

    return response.data;
  }
);

const editTutorialSlice = createSlice({
  name: 'tutorial',
  initialState: {
    tutorialData: {},
    loading: false,
    error: null,
  },
  reducers: {
    deleteTutorialPreviewImage: (state) => {
      state.tutorialData.preview_url = "";
    },
    setTutorialPreviewImage: (state, action) => {
      state.tutorialData.preview_url = action.payload.preview_url
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTutorialById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTutorialById.fulfilled, (state, action) => {
        state.loading = false;
        state.tutorialData = action.payload.data[0];
      })
      .addCase(fetchTutorialById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { deleteTutorialPreviewImage, setTutorialPreviewImage } = editTutorialSlice.actions;
export default editTutorialSlice.reducer;
